/* GHALIA — Craftsmanship page: sticky step rail, scroll progress, active step sync */
(function () {
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  const root = $('[data-craftsmanship]');
  if (!root) return;

  const railShell = $('[data-craft-rail-shell]', root);
  const hero = $('.craft__hero', root);
  const rail = $('[data-craft-rail]', root);
  const progress = $('[data-craft-progress]', root);
  const navLinks = $$('[data-craft-nav]', root);
  const steps = $$('[data-craft-step]', root);
  if (!steps.length) return;

  const getHeaderBottom = () => {
    const header = document.querySelector('.site-header[data-site-header]');
    if (!header) return 92;
    const rect = header.getBoundingClientRect();
    const height = header.offsetHeight || 92;
    /* Header pinned at top — rail sits directly below, no announcement gap */
    if (rect.top <= 0) return height;
    if (rect.bottom > 0) return Math.round(rect.bottom);
    return height;
  };

  const syncMetrics = () => {
    const headerBottom = getHeaderBottom();
    const railH = railShell ? railShell.offsetHeight : 72;
    document.documentElement.style.setProperty('--craft-rail-top', `${headerBottom}px`);
    root.style.setProperty('--craft-rail-h', `${railH}px`);
  };

  const updateRailState = () => {
    syncMetrics();
    if (!railShell || !hero) return;
    const headerBottom = getHeaderBottom();
    const heroBottom = hero.getBoundingClientRect().bottom;
    railShell.classList.toggle('is-scrolled', heroBottom <= headerBottom + 8);
  };

  const scrollOffset = () => {
    updateRailState();
    return getHeaderBottom() + (railShell ? railShell.offsetHeight : 72) + 16;
  };

  updateRailState();
  window.addEventListener('resize', updateRailState, { passive: true });

  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - scrollOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });

  const setActive = (index) => {
    navLinks.forEach((link, i) => {
      const active = i === index;
      link.classList.toggle('is-active', active);
      link.setAttribute('aria-current', active ? 'step' : 'false');
    });
    const activeLink = navLinks[index];
    if (activeLink && rail) {
      const railRect = rail.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      if (linkRect.left < railRect.left || linkRect.right > railRect.right) {
        activeLink.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }
  };

  const updateProgress = () => {
    if (!progress) return;
    const first = steps[0];
    const last = steps[steps.length - 1];
    const start = first.getBoundingClientRect().top + window.scrollY;
    const end = last.getBoundingClientRect().top + window.scrollY + last.offsetHeight;
    const viewportMid = window.scrollY + window.innerHeight * 0.35;
    const pct = Math.min(100, Math.max(0, ((viewportMid - start) / (end - start)) * 100));
    progress.style.width = pct + '%';
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.stepIndex);
            if (!Number.isNaN(idx)) setActive(idx);
          }
        });
      },
      { rootMargin: '-35% 0px -45% 0px', threshold: 0 }
    );
    steps.forEach((step) => io.observe(step));
  }

  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateProgress();
        updateRailState();
        ticking = false;
      });
    },
    { passive: true }
  );

  updateProgress();
})();
